import { render } from "./ModalSalesReturnDetail.vue?vue&type=template&id=d4aa2e6e"
import script from "./ModalSalesReturnDetail.vue?vue&type=script&lang=js"
export * from "./ModalSalesReturnDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__